module.exports = __webpack_public_path__ + "media/images/noavatar-b098991837d18a252dec1201d04e20b9.png";